var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Card, Skeleton, SkeletonBlock, SkeletonLine, } from '@one-thd/sui-atomic-components';
import React from 'react';
export var CardSkeletonLoader = function (_a) {
    var shape = _a.shape, _b = _a.isMobile, isMobile = _b === void 0 ? false : _b;
    return (React.createElement(React.Fragment, null, {
        DetailedCardDesktop: __spreadArray([], Array(3), true).map(function (_e, i) { return (React.createElement("div", { key: i, className: "sui-mb-6" },
            React.createElement(Card, null,
                React.createElement("div", { className: "sui-flex sui-min-w-full sui-gap-10" },
                    React.createElement("div", { className: "sui-w-5/12 sui-flex sui-flex-col sui-gap-4" },
                        React.createElement(SkeletonLine, { variant: "heading", fullWidth: true }),
                        React.createElement(SkeletonLine, { numberOfLines: 3 }),
                        React.createElement(Skeleton, { disablePadding: true, orientation: "horizontal" }, __spreadArray([], Array(4), true).map(function (__f, jkey) { return (React.createElement("div", { key: jkey },
                            React.createElement(SkeletonBlock, { height: 12, width: 12 }))); }))),
                    React.createElement("div", { className: "sui-w-7/12 sui-flex sui-flex-col sui-gap-4" },
                        React.createElement("div", { className: "sui-ml-auto sui-mb-auto" },
                            React.createElement(SkeletonBlock, { height: 8, width: 8 })),
                        React.createElement(SkeletonLine, { numberOfLines: 3 }),
                        React.createElement(SkeletonLine, { variant: "heading", fullWidth: true })))))); }),
        DetailedCardMobile: __spreadArray([], Array(3), true).map(function (_e, i) { return (React.createElement("div", { key: i, className: "sui-mb-6" },
            React.createElement(Card, { href: "#" },
                React.createElement("div", { className: "sui-flex sui-min-w-full sui-gap-10" },
                    React.createElement("div", { className: "sui-w-full sui-flex sui-flex-col sui-gap-4" },
                        React.createElement(SkeletonLine, { variant: "heading", fullWidth: true }),
                        React.createElement(SkeletonLine, { numberOfLines: 3 }),
                        React.createElement("div", { className: "sui-flex sui-gap-3" }, __spreadArray([], Array(4), true).map(function (__f, jkey) { return (React.createElement("div", { key: jkey },
                            React.createElement(SkeletonBlock, { height: 12, width: 12 }))); })),
                        React.createElement(SkeletonLine, { variant: "heading", fullWidth: true })))))); }),
        SimpleCardDesktop: __spreadArray([], Array(3), true).map(function (_e, i) { return (React.createElement("div", { key: i, className: "sui-mb-6" },
            React.createElement(Card, { href: "#" },
                React.createElement("div", { className: "sui-flex sui-min-w-full sui-gap-10" },
                    React.createElement("div", { className: "sui-w-5/12 sui-flex sui-flex-col sui-gap-4" },
                        React.createElement(SkeletonLine, { variant: "heading", fullWidth: true }),
                        React.createElement(SkeletonLine, { variant: "single" })),
                    React.createElement("div", { className: "sui-w-7/12 sui-flex sui-flex-col sui-gap-4" },
                        React.createElement("div", { className: "sui-ml-auto sui-mb-auto" },
                            React.createElement(SkeletonBlock, { height: 8, width: 8 }))))))); }),
        SimpleCardMobile: __spreadArray([], Array(3), true).map(function (_e, i) { return (React.createElement("div", { key: i, className: "sui-mb-6" },
            React.createElement(Card, { href: "#" },
                React.createElement("div", { className: "sui-flex min-w-full sui-gap-10" },
                    React.createElement("div", { className: "sui-min-w-full sui-flex sui-flex-col sui-gap-4" },
                        React.createElement(SkeletonLine, { variant: "heading", fullWidth: true }),
                        React.createElement(SkeletonLine, { variant: "single" })),
                    React.createElement("div", { className: "sui-w-7/12 sui-flex sui-flex-col sui-gap-4" },
                        React.createElement("div", { className: "sui-ml-auto sui-mb-auto" },
                            React.createElement(SkeletonBlock, { height: 8, width: 8 }))))))); }),
    }[String("".concat(shape).concat(isMobile ? 'Mobile' : 'Desktop'))]));
};
/**
 * A skeleton for the detail protion of the purchase history card
 * @returns Skeleton for the details portion of the purchase history card
 * Used for {PHCardDetailSkeleton} component
 */
var PHDetailPortionSkeleton = function () { return (React.createElement("div", { className: "sui-grid sui-grid-cols-1 md:sui-grid-cols-2 lg:sui-grid-cols-2 sui-mb-2 md:sui-h-[78px]" },
    React.createElement("div", { className: "sui-p-1" },
        React.createElement(SkeletonLine, { variant: "single" }),
        React.createElement(Skeleton, { disablePadding: true, orientation: "horizontal" }, __spreadArray([], Array(4), true).map(function (__f, jkey) { return (React.createElement("div", { key: jkey, className: "sui-pt-1" },
            React.createElement(SkeletonBlock, { height: 12, width: 12 }))); }))),
    React.createElement("div", { className: "sui-p-1" },
        React.createElement(SkeletonLine, { numberOfLines: 2 })))); };
/**
 * Function that allows developer to request how many detail skeletons to render in PH card.
 * @param numberOfSkeletons - Number of detail skeletons to render
 */
export var PHCardDetailSkeleton = function (_a) {
    var numberOfSkeletons = _a.numberOfSkeletons;
    if (numberOfSkeletons) {
        var elements = [];
        for (var i = 0; i < numberOfSkeletons; i += 1) {
            elements.push(React.createElement(PHDetailPortionSkeleton, { key: i }));
        }
        return React.createElement("div", null, elements);
    }
    return React.createElement(PHDetailPortionSkeleton, null);
};
